import { useState, useEffect, useCallback } from 'react';
import { fetchKpisCuadre } from '../services/reportesV2.services';

// Hook: KPIs y Cuadre del periodo
// Carga solo cuando hay lavanderia y rango de fechas seleccionados.
export const useKpisCuadre = ({ idLavanderia, dateRange, enabled = true }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled || !idLavanderia || !dateRange) return;
    setLoading(true);
    setError(null);
    try {
      const result = await fetchKpisCuadre({ idLavanderia, dateRange });
      setData(result);
    } catch (e) {
      setError(e.message || 'Error al cargar KPIs');
    } finally {
      setLoading(false);
    }
  }, [idLavanderia, dateRange, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
